import React, { useState, useEffect } from "react";
import { CheckCircle, Video } from "lucide-react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, useLocation } from "react-router-dom";

const PreCallChecklist = () => {
  const navigate = useNavigate();
  const [checks, setChecks] = useState({
    speaker: false,
    microphone: false,
    camera: false,
  });

  const location = useLocation();

  const appointment = location.state || null;
  console.log("PreCallChecklist appointment:", appointment);
  // Simulate device test animation
  useEffect(() => {
    const timer1 = setTimeout(() => setChecks((c) => ({ ...c, speaker: true })), 800);
    const timer2 = setTimeout(() => setChecks((c) => ({ ...c, microphone: true })), 1600);
    const timer3 = setTimeout(() => setChecks((c) => ({ ...c, camera: true })), 2400);
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
    };
  }, []);

  const allReady = Object.values(checks).every(Boolean);

  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center text-center min-vh-100"
      style={{
        background: "var(--primary)",
        padding: "20px",
      }}
    >
      {/* Glowing camera icon */}
      <div
        className="d-flex justify-content-center align-items-center mb-4"
        style={{
          width: 120,
          height: 120,
          borderRadius: 32,
          background: "rgba(255,255,255,0.15)",
          boxShadow: "0 8px 30px rgba(0,0,0,0.1)",
        }}
      >
        <Video size={64} color="#c4b5fd" />
      </div>

      {/* Title */}
      <h5 className="fw-bold text-white mb-4">
        Testing your speaker, microphone, and camera...
      </h5>

      {/* Checklist */}
      <div className="bg-white shadow rounded-4 p-4 text-start" style={{ width: "100%", maxWidth: 360 }}>
        {[
          { key: "speaker", label: "Speaker" },
          { key: "microphone", label: "Microphone" },
          { key: "camera", label: "Camera" },
        ].map((item) => (
          <div key={item.key} className="d-flex align-items-center mb-3">
            <div
              className="d-flex justify-content-center align-items-center me-3"
              style={{
                width: 28,
                height: 28,
                borderRadius: "50%",
                backgroundColor: checks[item.key] ? "#22c55e1a" : "#f1f5f9",
              }}
            >
              {checks[item.key] && <CheckCircle size={20} color="#22c55e" />}
            </div>
            <span
              style={{
                fontWeight: 500,
                color: "#111827",
                fontSize: 15,
              }}
            >
              {item.label}
            </span>
          </div>
        ))}

        {/* Continue Button */}
        <button
          disabled={!allReady}
          onClick={() => navigate(`/call/${appointment.roomId}`, { state: appointment })}
          className="btn w-100 fw-semibold rounded-3 py-2 mt-3"
          style={{
            backgroundColor: allReady ? "#7c3aed" : "#c4b5fd",
            color: "#fff",
            fontSize: 16,
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          }}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default PreCallChecklist;
